import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

  * {
    outline: none;
    box-sizing: border-box;
    margin: 0;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  html, input, select, textarea {
    font-family: Poppins;
    font-weight: 300;
    color: #353d53;
  }

  body {
    background-color: transparent; 
    line-height: 1.3;
  }
  
  h1, h2, h3, h4 {
    font-weight: 700;
  }

  h2 {
    font-size: 2.875rem;
    margin-bottom: 0.1rem;
  }

  h3 {
    font-size: 1.25rem;
    margin-bottom: 0.1rem;
  }

  a {
    color: #00c2ff;
    font-weight: 500;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  p {
    margin-bottom: 1rem;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type=number] {
    text-align: left;
    -moz-appearance: textfield;
  }
`;

export default GlobalStyle;
